import {Callout}              from '@/domains/markdoc/components/Callout';
import {CallToAction}         from '@/domains/markdoc/components/CallToAction';
import {
	QuickLink,
	QuickLinks,
}                             from '@/domains/markdoc/components/QuickLinks';
import {TLDR}                 from '@/domains/markdoc/components/TLDR';
import {Tweet}                from '@/domains/markdoc/components/Tweet';
import Demo                   from '@/domains/shared/components/Demo';
import {TorchlightCollection} from '@/domains/shared/components/TorchlightCollection';

const tags = {
	callout: {
		attributes: {
			title: {type: String},
			type:  {
				type:       String,
				default:    'note',
				matches:    [
					'note',
					'warning',
				],
				errorLevel: 'critical',
			},
		},
		render:     Callout,
	},

	'call-to-action': {
		selfClosing: true,
		attributes:  {
			title:      {type: String},
			subtitle:   {type: String},
			buttonType: {
				type:       String,
				default:    'savvycal',
				matches:    [
					'href',
					'savvycal',
				],
				errorLevel: 'critical',
			},
			buttonText: {
				type:       String,
				default:    'Book a free call with our founder',
				errorLevel: 'critical',
			},
			buttonHref: {
				type:    String,
				default: null, // '/contact-us',
			},
		},
		render:      CallToAction,
	},

	demo: {
		attributes: {
			demo: {type: String},
			src: {type: String},
		},
		render:     Demo,
	},

	figure: {
		selfClosing: true,
		attributes:  {
			src:     {type: String},
			alt:     {type: String},
			caption: {type: String},
		},
		render:      ({
			              src,
			              alt = '',
			              caption,
		              }) => (<figure>
			{/* eslint-disable-next-line @next/next/no-img-element */}
			<img src={src}
			     alt={alt}
			/>

			<figcaption>{caption}</figcaption>
		</figure>),
	},

	tldr: {
		attributes: {
			title: {type: String},
		},
		render:     TLDR,
	},

	'torchlight-collection': {
		attributes: {
			type: {
				type:    String,
				default: 'tabs',
			},
		},
		render:     TorchlightCollection,
	},

	tweet: {
		attributes: {
			url: {type: String},
		},
		render:     Tweet,
	},

	'quick-links': {
		render: QuickLinks,
	},

	'quick-link': {
		selfClosing: true,
		render:      QuickLink,
		attributes:  {
			title:       {type: String},
			description: {type: String},
			icon:        {type: String},
			href:        {type: String},
		},
	},
};

export default tags;
